import userIcon from './../../images/userIcon.png';
import billingIcon from './../../images/billingIcon.png';
import { SERVICE_GROUPS } from '../../../../components/myeirconstant/myEirConstant';
import broadbandIcon from './../../images/broadbandIcon.png';
import mobileIcon from './../../images/phoneIcon.png';
import tvIcon from './../../images/tvIcon.png';

const { DUALPLAY, DUALPLAY_PSTN, SA_PSTN, TV, MOBILE } = SERVICE_GROUPS;
export const getHelpServices = () => {
    const subscriptions = JSON.parse(
        sessionStorage.getItem('LoggedinUserSubscriptionIDandAccountID')
    );
    const hasPayment = (JSON.parse(sessionStorage.getItem('myBalance')) / 100).toFixed(2) < 0;
    const services = [
        {
            icon: billingIcon,
            title: 'Billing & Payments',
            links: [
                hasPayment && {
                    name: 'Make a payment',
                    url: '/account/dashboard?action=payment',
                    action: 'OPEN_PAYMENT_MODAL',
                },
                {
                    name: 'View and download my bills',
                    url: '/account/bills',
                    action: '',
                },
                {
                    name: 'View my payment history',
                    url: '/account/payments',
                    action: '',
                },
                {
                    name: 'Track my usage',
                    url: '/account/dashboard?action=usage',
                    action: 'OPEN_USAGE_MODAL',
                },
            ],
        },
        {
            icon: userIcon,
            title: 'Account',
            links: [
                {
                    name: 'View account number',
                    url: '/account/details',
                },
                {
                    name: 'View account details',
                    url: '/account/details',
                },
                {
                    name: 'Contract information',
                    url: '/account/contracts',
                },
                { name: 'Account preferences', url: '/account/preferences' },
            ],
        },
    ];
    const serviceGroups = [...new Set(subscriptions.map(subs => subs.serviceGroup))];
    const BROADBAND_SERVICE_WITH_APV = {
        icon: broadbandIcon,
        title: 'eir Broadband',
        links: [
            {
                name: 'Manage Amazon Prime',
                url: '/account/dashboard?action=apv',
                action: 'OPEN_APV_MODAL',
            },
            {
                name: 'View UAN',
                url: '/account/contracts',
                action: '',
            },
        ],
    };
    const BROADBAND_SERVICE = {
        icon: broadbandIcon,
        title: 'eir Broadband',
        links: [
            {
                name: 'View UAN',
                url: '/account/contracts',
                action: '',
            },
        ],
    };
    const TV_SERVICE = {
        icon: tvIcon,
        title: 'eir TV',
        links: [
            {
                name: 'Manage Amazon Prime',
                url: '/account/dashboard?action=apv',
                action: 'OPEN_APV_MODAL',
            },
            {
                name: 'Manage my TV PIN',
                url: '/account/dashboard?action=tvpin',
                action: 'OPEN_TV_PIN_MODAL',
            },
            {
                name: 'Manage my devices',
                url: '/account/dashboard?action=devices',
                action: 'OPEN_DEVICE_MANAGEMENT_MODAL',
            },
        ],
    };
    const MOBILE_SERVICE = {
        icon: mobileIcon,
        title: 'eir Mobile',
        links: [
            {
                name: 'PIN & PUK',
                url: '/account/dashboard?action=pinPuk',
                action: 'OPEN_PIN_PUK_MODAL',
            },
            {
                name: 'Keep my old number',
                url: '/account/dashboard?action=porting',
                action: 'OPEN_PORTING_MODAL',
            },
            {
                name: 'Order replacement SIM',
                url: '/account/simreplacement',
                action: '',
            },
        ],
    };

    const dualPlaySubs =
        serviceGroups.includes(DUALPLAY) ||
        serviceGroups.includes(DUALPLAY_PSTN) ||
        serviceGroups.includes(SA_PSTN);
    const tvSubs = serviceGroups.includes(TV);
    const mobileSubs = serviceGroups.includes(MOBILE);
    if (dualPlaySubs && tvSubs && mobileSubs) {
        services.push(BROADBAND_SERVICE, TV_SERVICE, MOBILE_SERVICE);
    } else if (dualPlaySubs && tvSubs) {
        services.push(BROADBAND_SERVICE, TV_SERVICE);
    } else if (dualPlaySubs && mobileSubs) {
        services.push(BROADBAND_SERVICE_WITH_APV, MOBILE_SERVICE);
    } else if (dualPlaySubs) {
        services.push(BROADBAND_SERVICE_WITH_APV);
    } else if (mobileSubs) {
        services.push(MOBILE_SERVICE);
    }

    return services;
};
